import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  serviceType: null,
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setServiceType(state, action) {
      state.serviceType = action.payload;
    },
  },
});

export const { setServiceType } = serviceSlice.actions;
export default serviceSlice.reducer;
